module.exports = __webpack_public_path__ + "img/Ryan_Headshot-photoaidcom-cropped.913ec490.JPG";